module.exports = __webpack_public_path__ + "img/Gaming-amico.220ddf10.svg";